import { jobInterestsDefaultValue } from '$constants/formDefaultValues';
import {
  CandidateBuilder,
  GetSharedCandidatesRosterDataInput,
  GetSharedCandidatesRosterDataOutput,
} from '../candidates.types';

export const getSharedCandidatesRosterData = (builder: CandidateBuilder) =>
  builder.query<
    GetSharedCandidatesRosterDataOutput,
    GetSharedCandidatesRosterDataInput
  >({
    query: ({ sharedRosterId }) => {
      return {
        url: `/candidates/share/${sharedRosterId}`,
        method: 'GET',
      };
    },
    transformResponse: (response: GetSharedCandidatesRosterDataOutput) => {
      response.candidates = response.candidates.map((singleCandidate) => {
        if (!singleCandidate.CandidateJobInterest) {
          singleCandidate.CandidateJobInterest = {
            Id: -1,
            SalaryLowerBound: jobInterestsDefaultValue.Salary[0],
            SalaryUpperBound: jobInterestsDefaultValue.Salary[1],
          };
        }
        return singleCandidate;
      });
      return response;
    },
  });
